import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $isOpen: boolean }>`
  position: relative;
  width: 240px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ $isOpen }) =>
    $isOpen ? 'var(--switcher-open)' : 'var(--textAndLabels-tertiary)'};
  transition: color 0.3s ease;
`;

export const SelectedLanguage = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 16px;
`;

export const Dropdown = styled.div<{ $isOpen: boolean }>`
  z-index: 1;
  position: absolute;
  top: -172px;
  display: flex;
  width: 100%;
  padding: 10px 5px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 28px;
  background: var(--bg-main);
  box-shadow: 0 17px 34px 0 rgba(0, 0, 0, 0.08);
  transition:
    opacity 0.3s ease,
    transform 0.3s ease,
    visibility 0.3s;

  ${({ $isOpen }) =>
    $isOpen
      ? css`
          visibility: visible;
          opacity: 1;
          transform: translateY(0);
        `
      : css`
          visibility: hidden;
          opacity: 0;
          transform: translateY(10px);
        `}
`;

export const Option = styled.div<{
  $isSelected: boolean;
}>`
  padding: 13px 15px;
  cursor: pointer;
  border-radius: 28px;
  width: 100%;
  color: var(--textAndLabels-main);
  background: ${({ $isSelected }) =>
    $isSelected ? 'var(--bg-secondary)' : 'var(--bg-main)'};
  text-align: start;

  &:hover {
    color: ${({ $isSelected }) =>
      !$isSelected ? 'var(--custom-yellow)' : 'var(--system-yellow)'};
  }
  transition: color 0.2s ease;
`;

export const Arrow = styled.div<{ $isOpen: boolean }>`
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.3s ease;
`;
